import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { initializeFirebasePerformance } from './firebase.js';

const startApp = () => {
  initializeFirebasePerformance();

  const staticSeoFallback = document.getElementById('seo-static-fallback');
  if (staticSeoFallback) {
    staticSeoFallback.remove();
  }

  document.querySelectorAll('[data-static-seo="true"]').forEach((node) => {
    node.remove();
  });

  const rootElement = document.getElementById('root');
  const app = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
  } else {
    const root = createRoot(rootElement);
    root.render(app);
  }

  reportWebVitals();
};

if (document.prerendering) {
  document.addEventListener('prerenderingchange', startApp, { once: true });
} else {
  startApp();
}
